import CONSTS from '../shared/constants.json';
const { KENKYU_SHUBETSU, KENKYU_MOKEI, KENKYU_Sonota = [], Representative_Class, SHOZOKU_LIST } = CONSTS;

export default function MonthForm({ info, onChange }) {
  const sel = (label, key, options, placeholder = "選択してください", required = false) => (
    <div className="field" style={{ alignSelf: "start" }}>
      <label className="field-label">
        {label}
        {required && <span style={{ color: "red", marginLeft: 8 }}>※必須</span>}
      </label>
      <select className="field-input" value={info[key]} onChange={e => onChange(key, e.target.value)}>
        <option value="">{placeholder}</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  const inp = (label, key, type = "text", placeholder = "", required = false) => (
    <div className="field" style={{ alignSelf: "start" }}>
      <label className="field-label">
        {label}
        {required && <span style={{ color: "red", marginLeft: 8 }}>※必須</span>}
      </label>
      <input className="field-input" type={type} value={info[key]}
        onChange={e => onChange(key, type === "number" ? Number(e.target.value) : e.target.value)}
        placeholder={placeholder} />
    </div>
  );

  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const years = [2024, 2025, 2026, 2027];

  return (
    <div className="card">
      <h2 className="section-title">月次・研究情報</h2>
      <p className="help-text">毎月変わる情報を入力してください。従事者情報はタブ②で確認・変更できます。</p>

      {/* <div className="form-grid">
        <div className="field">
          <label className="field-label">年</label>
          <select className="field-input" value={info.year} onChange={e => onChange("year", Number(e.target.value))}>
            {years.map(y => <option key={y} value={y}>{y}年</option>)}
          </select>
        </div>
        <div className="field">
          <label className="field-label">月</label>
          <select className="field-input" value={info.month} onChange={e => onChange("month", Number(e.target.value))}>
            {months.map(m => <option key={m} value={m}>{m}月</option>)}
          </select>
        </div> */}

      <div className="form-grid" style={{ alignItems: "start" }}>
        {sel("年", "year", years, "選択してください", true)}
        {sel("月", "month", months, "選択してください", true)}
        {/* 改行：年・月の行を確定して次のフィールドを新しい行から開始 */}
        <div style={{ gridColumn: "1 / -1", height: 0 }} />

        {sel("研究種目", "kenkyuShumoku", KENKYU_MOKEI, "該当なし", false)}
        {sel("代表者区分", "daihyoushaKubun", Representative_Class, "該当なし", false)}

        {/* 改行：以降のフィールドを新しい行から開始する */}
        <div style={{ gridColumn: "1 / -1", height: 0 }} />

        {/* {sel("管理者所属", "kanrishaShozoku", SHOZOKU_LIST, "選択してください", true)} */}
        {/* {sel("研究種別", "kenkyuShubetsu", KENKYU_SHUBETSU, "選択してください", true)} */}
        {/* 研究種別：'その他研究費' 選択時に右側に詳細入力を表示 */}
        {/* このブロックを1行全体に広げて、他セルの高さに影響しないようにする */}
        <div style={{ gridColumn: "1 / -1", display: "flex", gap: 8, alignItems: "center" }}>
          {sel("研究種別", "kenkyuShubetsu", KENKYU_SHUBETSU, "選択してください", true)}
          {info.kenkyuShubetsu === "その他研究費" && (
            <div className="field" style={{ flex: 1, margin: 0, alignSelf: "center" }}>
              <label className="field-label">内容</label>
              <div style={{ display: "flex", gap: 8 }}>
                <select
                  className="field-input"
                  value={KENKYU_Sonota.includes(info.kenkyuShumoku) ? info.kenkyuShumoku : (info.kenkyuShumokuChoice || "")}
                  onChange={e => {
                    const v = e.target.value;
                    if (v === "__custom__") {
                      // 自由入力選択：カスタムモードに切替（ko保存フィールドは空文字に）
                      onChange("kenkyuShumokuChoice", "__custom__");
                      onChange("kenkyuShumoku", "");
                    } else {
                      onChange("kenkyuShumokuChoice", v);
                      onChange("kenkyuShumoku", v);
                    }
                  }}
                >
                  <option value="">選択してください</option>
                  {KENKYU_Sonota.map(o => <option key={o} value={o}>{o}</option>)}
                  <option value="__custom__">自由入力</option>
                </select>

                {/* 自由入力モードまたは既にカスタム文字列がある場合に表示 */}
                {(info.kenkyuShumokuChoice === "__custom__") || (info.kenkyuShumoku && !KENKYU_Sonota.includes(info.kenkyuShumoku)) ? (
                  <input
                    className="field-input"
                    type="text"
                    value={info.kenkyuShumoku || ""}
                    onChange={e => {
                      onChange("kenkyuShumoku", e.target.value);
                      onChange("kenkyuShumokuChoice", "__custom__");
                    }}
                    placeholder="例：消耗品費、備品費など"
                    style={{ flex: 1 }}
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>

        {/* 改行：以降のフィールドを新しい行から開始する */}
        <div style={{ gridColumn: "1 / -1", height: 0 }} />

        {inp("管理者氏名", "kanrishaName", "text", "例：中村聡史", true)}

        <div className="field" style={{ alignSelf: "start" }}>
          <label className="field-label">
            時給（円）
            <span style={{ color: "red", marginLeft: 8 }}>※必須</span>
          </label>
          <select
            className="field-input"
            value={String(info.hourlyWage || "")}
            onChange={e => onChange("hourlyWage", Number(e.target.value))}
          >
            <option value="">選択してください</option>
            {[1250, 1600].map(w => <option key={w} value={w}>{w}円</option>)}
          </select>
        </div>
      </div>

      <div className="info-box">
        <strong>プロフィール連携</strong><br />
        従事者情報は、ログイン中の本人が profile.nkmr.io に登録した内容から取得します。
      </div>
    </div>
  );
}
